import { render, staticRenderFns } from "./OctChip.vue?vue&type=template&id=358de8ec&scoped=true&"
import script from "./OctChip.vue?vue&type=script&lang=js&"
export * from "./OctChip.vue?vue&type=script&lang=js&"
import style0 from "./OctChip.vue?vue&type=style&index=0&id=358de8ec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "358de8ec",
  null
  
)

export default component.exports